import _ from 'lodash'
import api from './Api'

export const searchNSCustomersDebounced = value => {
  return new Promise((resolve, reject) =>
    _searchNSCustomersDebounced({ value, resolve, reject }),
  )
}

const _searchNSCustomersDebounced = _.debounce(
  async ({ value, resolve, reject }) => {
    try {
      const response = await api.get(`/netsuitecustomers?nsCustomerId=${value}`)
      resolve(response)
    } catch (err) {
      reject(err)
    }
  },
  300,
)

export const formatSiteForSchoolLookUp = school => {
  const { address } = school
  const { city, country, region } = address || {}
  const nsCustomerId =
    school.nsCustomerId ||
    (school.netSuiteCustomer && school.netSuiteCustomer.nsCustomerId) ||
    null
  // Check for direct netsuiteCustomerId field first (backward compatibility),
  // then fall back to extracting from netSuiteCustomer.id
  const netsuiteCustomerId =
    school.netsuiteCustomerId !== undefined &&
    school.netsuiteCustomerId !== null
      ? school.netsuiteCustomerId
      : school.netSuiteCustomer?.id || 0
  const hasNsCustomerId = !!nsCustomerId || netsuiteCustomerId !== 0

  return {
    city,
    companyName: hasNsCustomerId ? school.name : '',
    country,
    netsuiteCustomerId: netsuiteCustomerId,
    nsCustomerId: nsCustomerId || '',
    region,
    organizationName: !hasNsCustomerId ? school.name : '',
  }
}

export const formatNetsuiteCustomerForSchoolLookUp = netsuiteCustomer => {
  const { address } = netsuiteCustomer
  const { city, country, region } = address || {}

  const hasNsCustomerId = !!netsuiteCustomer.nsCustomerId

  return {
    city,
    companyName: hasNsCustomerId ? netsuiteCustomer.companyName : '',
    country,
    netsuiteCustomerId: hasNsCustomerId ? netsuiteCustomer.id : 0,
    nsCustomerId: netsuiteCustomer.nsCustomerId || '',
    region,
    organizationName: hasNsCustomerId ? netsuiteCustomer.companyName : '',
  }
}
